// @flow

import * as React from "react";
import { Button } from "react-bootstrap";

import "./TimeoutScreen.css";

type TimeoutScreenProps = {
  continue: () => void
};

const TimeoutScreen = (props: TimeoutScreenProps) => (
  <div className="TimeoutScreen">
    <div className="TimeoutScreen-Title">Timeout</div>
    <div className="TimeoutScreen-Text">
      <p>Try not to let this happen.</p>
      <p>If you have no idea at all, you can always click 50%.</p>
    </div>
    <div className="TimeoutScreen-Controls">
      <Button bsSize="large" onClick={props.continue}>
        Next question
      </Button>
    </div>
  </div>
);

export default TimeoutScreen;



// WEBPACK FOOTER //
// ./src/components/Task/TimeoutScreen.js